(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-welcome-offer"]) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = 'aloren-welcome10-dismissed-v1';
    const preview = root.dataset.preview === 'true';
    const days = Number(root.dataset.days) || 7;
    const status = root.querySelector('[role="status"]');
    const codeInput = root.querySelector('.al-welcome__code input');
    const submitted = !!root.querySelector('[data-offer-success], [data-offer-errors]');
    const copy = root.querySelector('[data-offer-copy]');
    let timer;
    function remember() {
      try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {}
    }
    function close() { remember(); dialog.close(); }
    function show() {
      if (!root.isConnected) return;
      if (!preview && !submitted) {
        try { if (Number(localStorage.getItem(key)) > Date.now()) return; } catch {}
      }
      if (document.hidden || document.querySelector('dialog[open]')) {
        timer = setTimeout(show, 3000);
        return;
      }
      dialog.showModal();
    }
    root.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', remember);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    root.querySelector('[data-offer-shop]')?.addEventListener('click', remember);
    copy?.addEventListener('click', async () => {
      try {
        if (!navigator.clipboard) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(root.dataset.code);
        status.textContent = root.dataset.copied;
      } catch {
        codeInput.focus();
        codeInput.select();
        status.textContent = root.dataset.copyHelp;
      }
    });
    timer = setTimeout(show, submitted ? 100 : preview ? 500 : Number(root.dataset.delay) || 5000);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { clearTimeout(timer); dialog.close(); }
    }, { once: true });
  }
  document.querySelectorAll('[data-al-welcome]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-al-welcome]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
